import { useEffect } from "react";
import { useApi, createApiHook } from "../utils/apiUtils";

const useFetchPhaseQuestionnaires = (applicationId, userId, phase) => {
  const { apiGet } = useApi();
  const useApiState = createApiHook(null);
  const { data, error, loading, startLoading, setResponse } = useApiState();

  useEffect(() => {
    if (!applicationId || !userId || !phase) return;

    const fetchData = async () => {
      startLoading();
      const response = await apiGet(
        `/aplicaciones/${applicationId}/phase_questionnaires?user_id=${userId}&phase=${phase}`,
        "Error al obtener los cuestionarios de la fase",
      );
      setResponse(response);
    };

    fetchData();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [applicationId, userId, phase]);

  return { data, error, loading };
};

export default useFetchPhaseQuestionnaires;
